import template from './assetFinanceCommissions.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    commission: '<',
    commissions: '<',
    financeProposal: '<',
    ticketOwner: '<',
    ticketPartners: '<',
    ticketAccountsAsPartners: '<',
    isSettlement: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $mdUtil,
      $mdMedia,
      helperService,
      homeLoanService,
      organizationsService,
      partnersService,
      accountsService,
      assetFinanceService,
      commissionService,
      ACCOUNT
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganizationRoot = null;
      ctrl.currentOrganizationGroup = null;
      ctrl.currentOrganization = null;
      ctrl.currentTicketOwner = null;
      ctrl.currentAccount = null;
      ctrl.currentDateFormat = null;
      ctrl.currentCurrency = null;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentTicketOwner = null;
        ctrl.currentAccount = $rootScope.CurrentAccount;
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.commission = ctrl.commission || {};
        ctrl.commissions = ctrl.commissions || [];
        ctrl.financeProposal = ctrl.financeProposal || [];
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.ticketPartners = ctrl.ticketPartners || [];
        ctrl.ticketAccountsAsPartners = ctrl.ticketAccountsAsPartners || [];
        ctrl.isSettlement = ctrl.isSettlement || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        const partners = _.uniq(ctrl.ticketPartners);
        const accountsAsPartners = _.uniq(ctrl.ticketAccountsAsPartners);
        $q.all([
          organizationsService.getRoot(),
          organizationsService.getGroup(),
          partners?.length
            ? partnersService.getSpecific({
                ids: partners,
                isActive: true,
                fields: ACCOUNT.FIELDS.CHIPS
              })
            : [],
          accountsAsPartners?.length
            ? accountsService.getSpecific({
                ids: accountsAsPartners,
                isActive: true,
                fields: ACCOUNT.FIELDS.CHIPS
              })
            : []
        ]).then((data) => {
          const currentOrganizationRoot = data[0][0];
          const currentOrganizationGroup = data[1][0];
          ctrl.currentOrganizationRoot = currentOrganizationRoot;
          ctrl.currentOrganizationGroup = currentOrganizationGroup;
          ctrl.currentTicketOwner = ctrl.ticketOwner;
          ctrl.currentTicketPartners = [];
          if (data[2]?.length) {
            ctrl.ticketPartners.forEach((id) => {
              const partner = _.find(data[2], (p) => p?.id === id);
              ctrl.currentTicketPartners.push(partner);
            });
          }
          ctrl.currentTicketAccountsAsPartners = [];
          if (data[3]?.length) {
            ctrl.ticketAccountsAsPartners.forEach((id) => {
              const accountAsPartner = _.find(data[3], (p) => p?.id === id);
              ctrl.currentTicketAccountsAsPartners.push(accountAsPartner);
            });
          }
          ctrl.commission = ctrl.commission || {};
          ctrl.commissions = ctrl.commissions || [];
          ctrl.financeProposal = ctrl.financeProposal || {};
          if (!ctrl.isTicketSettled) {
            ctrl.setCommission();
          } else {
            ctrl.isReady = true;
          }
        });
      };
      ctrl.isCommissionSplitsViewAllowed = () =>
        ctrl.currentAccount.isAdministrator ||
        ctrl.currentOrganization.permissions.usersCanSeeCommissionSplits;

      ctrl.setCommission = () => {
        if (!ctrl.commission?.isEdited) {
          ctrl.commission.commissionSplits = [];
          const commission = _.find(
            ctrl.commissions || [],
            (c) => c?.id === ctrl.commission?.idCommission
          );
          if (commission?.id) {
            ctrl.commission.commissionSplits = commissionService.mergeGenerics(
              commission.splits,
              ctrl.currentOrganizationRoot,
              ctrl.currentOrganizationGroup,
              ctrl.currentOrganization,
              ctrl.currentTicketOwner,
              ctrl.currentTicketPartners,
              ctrl.currentTicketAccountsAsPartners
            );
            ctrl.commission = assetFinanceService.setCommission({
              commission: ctrl.commission,
              financeProposal: ctrl.financeProposal,
              commissions: ctrl.commissions,
              isInitial: ctrl.commission?.idCommission === ''
            });
          }
        }
        ctrl.isReady = true;
        ctrl.saveAssetFinanceCommission();
      };

      ctrl.saveAssetFinanceCommission = _.debounce(() => {
        ctrl.onFinished({ commission: ctrl.commission });
      }, 2000);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
